import { VStack } from '@hover/blueprint';
import { breakpoints } from '@hover/blueprint/foundation';
import React from 'react';

import { Footer } from 'src/modules/pro/components/Footer';
import { HeroSection } from 'src/modules/pro/components/HeroSection';
import { ImageGrid } from 'src/modules/pro/components/ImageGrid';
import { VideoSection } from 'src/modules/pro/components/VideoSection';
import { TranslationNamespace } from 'src/shared/hooks';

import designerVideoDesktop from 'assets/video/designer-landing-landscape.mp4';
import designerVideoMobile from 'assets/video/designer-landing-portrait.mp4';

import { useHomeownerAppContext } from '../../hooks';
import { useShowSignInSheet } from '../../hooks/useShowSignInSheet';
import { HomeownerAppMenuNames } from '../../providers/HomeownerAppProvider';

import { BottomSection } from './components/BottomSection';
import { DesignYourHome } from './components/DesignYourHome';
import { Header } from './components/Header';
import { InfinityCarousel } from './components/InfinityCarousel';
import { TakeYourPlace } from './components/TakeYourPlace';

const DesignerLandingPage = () => {
  const { setCurrentMenu, trackingData } = useHomeownerAppContext();
  const onAddPhotoClick = () => {
    setCurrentMenu(HomeownerAppMenuNames.UPLOAD_PHOTO);
  };

  useShowSignInSheet();

  return (
    <>
      <VStack
        alignItems="center"
        height="100%"
        margin="0 auto"
        maxWidth={breakpoints.width500}
      >
        <Header />
        <HeroSection
          ctaTrackingData={{
            ...trackingData,
            button_location: 'Top of page cta',
            track_id: 'designer-lp-top-cta',
            primary_cta: true,
          }}
          onTryClick={onAddPhotoClick}
          translationName={TranslationNamespace.DESIGNER_LANDING_PAGE}
        />
        <ImageGrid
          onTryItCardClick={onAddPhotoClick}
          trackingData={trackingData}
        />
      </VStack>
      <VideoSection
        ctaTrackingData={{
          ...trackingData,
          primary_cta: true,
          track_id: 'designer-lp-customization-video',
        }}
        desktopVideoSource={designerVideoDesktop}
        mobileVideoSource={designerVideoMobile}
        onAddPhotoClick={onAddPhotoClick}
        primaryBackgroundColor="neutral.700"
        secondaryBackgroundColor="#252525"
        translationName={TranslationNamespace.DESIGNER_LANDING_PAGE}
      />
      <VStack
        alignItems="center"
        height="100%"
        margin="0 auto"
        maxWidth={breakpoints.width500}
        paddingX={{ base: 500, tablet: 800 }}
      >
        <DesignYourHome onTryClick={onAddPhotoClick} />
        <TakeYourPlace onAddPhotoClick={onAddPhotoClick} />
      </VStack>
      <InfinityCarousel />
      <BottomSection onTryClick={onAddPhotoClick} />
      <Footer />
    </>
  );
};

export { DesignerLandingPage };
